module.exports = __webpack_public_path__ + "img/2_no.8f125db2.svg";